import React from "react";
import clsx from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  allowDecimal?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: boolean;
  imageName?: string;
  startIcon?: any;
  forceDecimal?: boolean;
  negativeOnly?: boolean;
  negativeLabel?: boolean;
  iconOnClick?: () => void;
}

const onForceDecimal = (e: any) => {
  return (e.target.value = e.target.valueAsNumber.toFixed(2));
};

// FIXME: remove w-full
const BASE_STYLES =
  "border border-input-border font-medium rounded-xl text-text-primary outline-none bg-input-bg text-[13px] py-[10px] px-4 w-full h-[40px] transition-colors duration-200 placeholder:text-label-muted hover:border-edge-strong focus:border-indigo-400/50 focus:ring-1 focus:ring-indigo-500/30 focus-visible:border-indigo-400/50 disabled:cursor-not-allowed disabled:opacity-60";

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      disabled,
      helperText,
      className,
      allowDecimal,
      dataTestId,
      icon,
      imageName,
      startIcon,
      forceDecimal,
      negativeOnly,
      negativeLabel,
      iconOnClick,
      ...props
    }: InputProps,
    ref
  ) => {
    const allowStep = allowDecimal && props.type === "number";

    return (
      <div className="space-y-1.5 w-full">
        {label ? (
          <label
            className="text-label-muted font-medium block text-[12px] leading-4"
            data-testid="input-label"
            htmlFor={id}
          >
            {label}
          </label>
        ) : null}
        <div className="relative">
          {startIcon ? (
            <p className="h-full px-2 absolute left-2 top-[9px] text-heading-color font-medium">
              {startIcon}
            </p>
          ) : null}
          {negativeLabel ? (
            <p className="h-full px-2 absolute left-6 top-[9px] text-heading-color font-medium">
              -
            </p>
          ) : null}
          <input
            {...props}
            data-testid={dataTestId}
            aria-invalid={!!error}
            disabled={disabled}
            aria-disabled={disabled}
            id={id}
            step={allowStep ? "0.01" : undefined}
            ref={ref}
            onBlur={forceDecimal ? onForceDecimal : null}
            onInput={
              negativeOnly
                ? (e: any) => (e.target.value = -Math.abs(e.target.value))
                : null
            }
            className={clsx(
              BASE_STYLES,

              className,
              error && "border-ilara-red ring-1 ring-red-400/40",
              startIcon && "pl-8",
              startIcon && negativeLabel && "!pl-10"
            )}
          />
        </div>
        {icon ? (
          <img
            src={imageName}
            className="w-4 h-4 absolute top-0 !mt-8 mr-8 flex justify-center items-center right-0 cursor-pointer"
            alt=""
            onClick={iconOnClick}
          />
        ) : null}
        {error || helperText ? (
          <p
            className={`${
              error ? "text-red-500" : "text-ilara-secondary-text"
            } text-xs font-medium`}
            data-testid={error ? "input-error" : "input-helper-text"}
          >
            {error || helperText}
          </p>
        ) : null}
      </div>
    );
  }
);

export default CustomInput;
